<template>
  <div class="support-page">
    <div class="header-banner">
      <h1>Virtronex Support &amp; Help Center</h1>
      <p>Reliable technical support for your everyday corporate and business spending ecosystem</p>
    </div>

    <div class="container">
      <p class="intro-text">
        Welcome to the Virtronex Technical Support Center. Our specialized infrastructure teams are dedicated to
        ensuring your business payment experience remains completely secure, operational, and efficient. If you are
        experiencing installation issues, transaction management hurdles, or require dynamic card rule troubleshooting,
        find direct resources and human help below.
      </p>

      <div class="support-box">
        <h2>📞️ Connect Directly with Technical Support</h2>
        <p class="support-description">
          For accelerated troubleshooting and automated ticketing, please reach out to our dedicated operations desk.
          Our technical staff monitors incoming corporate queues constantly.
        </p>

        <table class="contact-table">
          <tr>
            <td class="contact-cell contact-cell-email">
              <div class="contact-method">
                <div class="contact-label">Technical Support Email</div>
                <div class="contact-value">support@virtronex.com</div>
              </div>
            </td>
            <td class="contact-cell">
              <div class="contact-method">
                <div class="contact-label">Standard Operating Hours</div>
                <div class="contact-value">9:00 AM – 6:00 PM (Mon – Fri)</div>
              </div>
            </td>
          </tr>
        </table>

        <div class="callout">
          <strong>🔑 Security Notice for Business Users:</strong> When opening a support request, please supply the full
          business registration email attached to your workspace along with screenshots of the error architecture.
          <strong>
            Never communicate full 16-digit card numbers, primary CVV parameters, or account passwords over email
            strings.
          </strong>
        </div>
      </div>

      <div class="footer">&copy; 2026 Virtronex Technologies Inc. All rights reserved.</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SupportPage",
};
</script>

<style scoped>
.support-page,
.support-page *,
.support-page *::before,
.support-page *::after {
  box-sizing: border-box;
}

@page {
  size: A4;
  margin: 15mm 12mm;
  background-color: #ffffff;
}

.support-page {
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  color: #1e293b;
  background-color: #ffffff;
  line-height: 1.6;
  font-size: 10.5pt;
  margin: 0;
  padding: 0;
  text-align: left;
}

.header-banner {
  padding: 30px 15mm;
  background: linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%);
  color: #ffffff;
}

.header-banner h1 {
  font-size: 22pt;
  margin: 0 0 8px 0;
  font-weight: 700;
  letter-spacing: 0;
}

.header-banner p {
  font-size: 11pt;
  margin: 0;
  color: #93c5fd;
  font-weight: 300;
}

.container {
  width: 100%;
}

.intro-text {
  font-size: 11pt;
  color: #475569;
  margin: 0 0 25px;
  padding: 24px 15mm 0;
}

.support-box {
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  margin: 0 15mm;
  padding: 20px;
}

.support-box h2 {
  font-size: 14pt;
  color: #0f172a;
  margin-top: 0;
  margin-bottom: 15px;
  font-weight: 600;
  display: block;
}

.support-description {
  margin-top: 0;
  margin-bottom: 15px;
  color: #475569;
}

.contact-table {
  width: 100%;
  border-collapse: collapse;
}

.contact-cell {
  width: 50%;
  vertical-align: top;
  padding: 0;
}

.contact-cell-email {
  padding-right: 15px;
}

.contact-method {
  margin-bottom: 15px;
}

.contact-label {
  font-weight: 600;
  color: #1e3a8a;
  font-size: 10pt;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 2px;
}

.contact-value {
  font-size: 12pt;
  font-weight: 700;
  color: #0f172a;
}

.callout {
  background-color: #fffbeb;
  border-left: 4px solid #f59e0b;
  border-radius: 0 6px 6px 0;
  padding: 12px 15px;
  margin-top: 20px;
  font-size: 9.5pt;
  color: #78350f;
}

.callout strong {
  color: #92400e;
}

.footer {
  margin: 40px 15mm 0;
  border-top: 1px solid #e2e8f0;
  padding-top: 15px;
  padding-bottom: 24px;
  font-size: 9pt;
  color: #94a3b8;
  text-align: center;
}

@media screen and (max-width: 640px) {
  .header-banner {
    padding: 28px 20px;
  }

  .header-banner h1 {
    font-size: 24px;
  }

  .intro-text {
    padding: 20px 20px 0;
  }

  .support-box {
    margin: 0 20px;
  }

  .contact-cell {
    display: block;
    width: 100%;
  }

  .contact-cell-email {
    padding-right: 0;
  }

  .footer {
    margin-right: 20px;
    margin-left: 20px;
  }
}
</style>
